export default "__VITE_ASSET__NIx3hEks__"